module.exports = __webpack_public_path__ + "img/scan_code.83f47026.svg";